/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_2_AnswerInputs */

const en_svc_rag_faq_2_answer = /** @type {(inputs: Svc_Rag_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common sources are Google Drive, SharePoint and OneDrive, Notion, help-centre articles, PDFs, spreadsheets and database records. We check formats and access during discovery.`)
};

const lv_svc_rag_faq_2_answer = /** @type {(inputs: Svc_Rag_Faq_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bieži izmantoti avoti ir Google Drive, SharePoint un OneDrive, Notion, palīdzības centra raksti, PDF faili, izklājlapas un datubāzu ieraksti. Formātus un piekļuvi pārbaudām izpētes laikā.`)
};

/**
* | output |
* | --- |
* | "Common sources are Google Drive, SharePoint and OneDrive, Notion, help-centre articles, PDFs, spreadsheets and database records. We check formats and access ..." |
*
* @param {Svc_Rag_Faq_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_2_answer = /** @type {((inputs?: Svc_Rag_Faq_2_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_2_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_2_answer(inputs)
	return en_svc_rag_faq_2_answer(inputs)
});